/**
 * Generato automaticamente.
 * OpenAPI
 */

export type EnumTipoDomandaDTOStato =
  (typeof EnumTipoDomandaDTOStato)[keyof typeof EnumTipoDomandaDTOStato];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumTipoDomandaDTOStato = {
  BOZZA: 'BOZZA',
  PRONTA: 'PRONTA',
  COLLAUDO: 'COLLAUDO',
  PUBBLICATA: 'PUBBLICATA',
  APERTA: 'APERTA',
  IN_CORSO: 'IN_CORSO',
  SOSPESA: 'SOSPESA',
  ANNULLATA: 'ANNULLATA',
  CHIUSA: 'CHIUSA',
} as const;
